function Header() {
  return (
  <>
    <header class="py-3 mb-4">
      <div class="container d-flex flex-wrap justify-content-center">
        <a href="/" class="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto text-dark text-decoration-none">
          <span class="fs-4">1001G+ Genome DB</span>
        </a>
        <form class="col-12 col-lg-auto mb-3 mb-lg-0" role="search">
          <input type="search" class="form-control" placeholder="Search..." aria-label="Search" />
        </form>
      </div>
    </header>
  </>
  );
}

export default Header;
